import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=45f1427c"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=45f1427c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports